/**
 * Politique de reconnexion WebSocket (Phase 2) — back-off exponentiel borné
 * avec gigue (jitter). Module pur et testable.
 */
export interface BackoffOptions {
  baseMs?: number
  maxMs?: number
  factor?: number
  /** Gigue relative (0..1) ; 0 = déterministe (tests). */
  jitter?: number
}

export class Backoff {
  private attempt = 0
  private readonly baseMs: number
  private readonly maxMs: number
  private readonly factor: number
  private readonly jitter: number

  constructor(opts: BackoffOptions = {}) {
    this.baseMs = opts.baseMs ?? 1000
    this.maxMs = opts.maxMs ?? 30000
    this.factor = opts.factor ?? 2
    this.jitter = opts.jitter ?? 0.2
  }

  /** Délai (ms) de la prochaine tentative, puis incrémente le compteur. */
  next(rand: () => number = Math.random): number {
    const raw = Math.min(this.maxMs, this.baseMs * this.factor ** this.attempt)
    this.attempt++
    const delta = raw * this.jitter
    return Math.round(raw - delta + rand() * 2 * delta)
  }

  /** Réinitialise après une connexion réussie. */
  reset(): void { this.attempt = 0 }

  get attempts(): number { return this.attempt }
}
